<template>
  <div
    class="overlay"
    :style="'background: ' + background + '; position: ' + position"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EpkOverlay',
  props: {
    background: {
      type: String,
      default: 'rgba(0, 0, 0, .6)',
    },
    position: {
      type: String,
      default: 'fixed',
    },
  },
};
</script>
<style src="./EpkOverlay.scss" lang="scss" />
